import { mergeOverrides } from 'baseui';
import { FormControl } from 'baseui/form-control';
import React, { ReactNode } from 'react';
import { FeedbackError } from '../../Icons/FeedbackError';
import { Warning } from '../../Icons/Warning';
import { getBaseCustomProps } from '../../Utilities/types/SharedProps';
import { getHTMLAttributes } from '../../Utilities/utils/Funtions/data-aria-attrs';
import { overrides } from './overrides';
import { LabelRequiredDot, LabelRequiredDotError } from './styles';
import { IDummyProps } from './types';

export const View = React.forwardRef((props: IDummyProps, ref: any) => {
	const { children, label, caption, overrides: passedOverrides, ...rest } = props;
	const HTMLAttrs = getHTMLAttributes(props);
	let finalLabel = label;
	let finalCaption: ReactNode = caption;

	if (props.required) {
		if (props.error) {
			finalLabel = (
				<>
					{label}
					<LabelRequiredDotError>•</LabelRequiredDotError>
				</>
			);
		} else {
			finalLabel = (
				<>
					{label}
					<LabelRequiredDot>•</LabelRequiredDot>
				</>
			);
		}
	}

	// Add icon to caption if form status is error or warning
	if (caption && (props.error || props.warning)) {
		const icon: ReactNode = props.error ? (
			<FeedbackError className="mr-xs" size={'18px'} />
		) : (
			<Warning className="mr-xs" size={'18px'} />
		);
		// Check if caption is a function or ReactNode to prevent regression issues
		if (typeof caption === 'function') {
			finalCaption = (
				<div className="d-flex align-items-center">
					{icon}
					<p className="m-0">{caption()}</p>
				</div>
			);
		} else {
			finalCaption = (
				<div className="d-flex align-items-center">
					{icon}
					<p className="m-0">{caption}</p>
				</div>
			);
		}
	}

	return (
		<div
			{...{
				id: props.id,
				'data-epo': 'epo-form-control',
				...getBaseCustomProps(props),
				...HTMLAttrs.dataProps,
				...HTMLAttrs.ariaProps,
				className: props.className,
			}}
		>
			<FormControl
				ref={ref}
				{...rest}
				label={finalLabel}
				caption={finalCaption}
				// @ts-ignore
				overrides={mergeOverrides(overrides(props), passedOverrides)}
			>
				{children}
			</FormControl>
		</div>
	);
});
